import { render, staticRenderFns } from "./EmployeeFoldersCard.vue?vue&type=template&id=afde84f4&scoped=true&"
import script from "./EmployeeFoldersCard.vue?vue&type=script&lang=js&"
export * from "./EmployeeFoldersCard.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeFoldersCard.vue?vue&type=style&index=0&id=afde84f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afde84f4",
  null
  
)

export default component.exports